module.exports = __webpack_public_path__ + "static/media/nl.pictogram.ec96e76c.svg";